export const MAX_ATTACHMENT_SIZE_MB = Number(import.meta.env.VITE_MAX_ATTACHMENT_SIZE_MB || 10)
export const PAGE_SIZES = import.meta.env.VITE_PAGE_SIZES ? import.meta.env.VITE_PAGE_SIZES.split(",").map(Number) : [10, 20, 50]
export const DEFAULT_PAGE_SIZE = PAGE_SIZES[0]
export const DEFAULT_PAGE = import.meta.env.VITE_DEFAULT_PAGE ? Number(import.meta.env.VITE_DEFAULT_PAGE) : 1
export const DEFAULT_SORT_DIRECTION = "desc" as "asc" | "desc"
export const DEFAULT_SORT_COLUMN = "createdAt"
export const API_URL = import.meta.env.VITE_BACKEND_URL
export const COUNTRY = { PERU: "Perú", ECUADOR: "Ecuador" } as const
// Claves de localStorage con este prefijo sobreviven al cierre de sesión (vistas de tablas, filtros, menú).
export const LOCAL_PREFERENCES_PREFIX = "suite-pref:"

export const LOCATION = {
  PERU: {
    LIMA: "Lima",
    TRUJILLO: "Trujillo",
    CHICLAYO: "Chiclayo",
    AREQUIPA: "Arequipa",
    PIURA: "Piura"
  },
  ECUADOR: {
    QUITO: "Quito",
    AMBATO: "Ambato",
    GUAYAQUIL: "Guayaquil",
    MACHALA: "Machala",
    MANTA: "Manta",
    CUENCA: "Cuenca",
    LOJA: "Loja"
  }
} as const

export const LOCATION_DATA = [
  { group: "Perú", items: Object.values(LOCATION.PERU) },
  { group: "Ecuador", items: Object.values(LOCATION.ECUADOR) }
] as const

export const ROLES = {
  // Key roles
  USER: "user",
  ADMIN: "admin",
  PROVIDER: "provider",

  // Specific functionality
  PRINT_STICKER: "printSticker",
  PURCHASE_REQUIREMENT_CREATE: "purchase-requirement-create",
  PURCHASE_REQUIREMENT_VIEW: "purchase-requirement-view",
  PURCHASE_REQUIREMENT_EDIT: "purchase-requirement-edit",
  PURCHASE_REQUIREMENT_DELETE: "purchase-requirement-delete",
  PURCHASE_APPROVAL_APPROVE: "purchase-approval-approve",
  PURCHASE_APPROVAL_REJECT: "purchase-approval-reject",
  PURCHASE_REQUIREMENT_APPROVER: "purchase-requirement-approver",
  PURCHASE_ORDER_CREATE: "purchase-order-create",
  PURCHASE_ORDER_VIEW: "purchase-order-view",
  PURCHASE_ORDER_EDIT: "purchase-order-edit",
  PURCHASE_ORDER_DELETE: "purchase-order-delete",
  PURCHASE_PAYMENT_SCHEDULE: "purchase-payment-schedule",
  PURCHASE_PAYMENT_SCHEDULE_EXCEPTION: "purchase-payment-schedule-exception",
  PURCHASE_PAYMENT_ACCOUNTING_REALIZE: "purchase-payment-accounting-realize",
  ANTICIPO_ADMIN: "anticipo-admin",
  ANTICIPO_USER: "anticipo-user",
  ANTICIPO_APROBADOR: "anticipo-aprobador",
  RENDICION_CONTABLE: "rendicion-contable",
  RENDICION_CONTABLE_PE: "rendicion-contable-pe",
  RENDICION_CONTABLE_EC: "rendicion-contable-ec",
  PURCHASE_PROVIDER_CREATE: "purchase-provider-create",
  PURCHASE_PROVIDER_VIEW: "purchase-provider-view",
  PURCHASE_PROVIDER_EDIT: "purchase-provider-edit",
  PURCHASE_PROVIDER_DELETE: "purchase-provider-delete",
  PURCHASE_INVOICE_VIEW: "purchase-invoice-view",
  EXTERNAL_PROVIDER: "external-provider",
  APPROVER_ADMINISTRATION: "approver-administration",
  TRAY_GUIDE: "tray-guide",
  TRAY_GUIDE_RETIRO: "tray-guide-retiro",
  TICKET_DATA_ADMIN: "ticket-data-admin",
  PROJECT_CREATOR: "project-creator",
  KPI_ADMIN: "kpi-admin",
  PRODUCT: "product",
  INV_SPECIALIZED: "inv-specialized",
  INV_SPECIALIZED_VIEW: "inv-specialized-view",
  INV_SPECIALIZED_CREATE: "inv-specialized-create",
  INV_SPECIALIZED_EDIT: "inv-specialized-edit",
  INV_SPECIALIZED_DELETE: "inv-specialized-delete",
  INV_SPECIALIZED_FLAGS: "inv-specialized-flags",
  BANDEJAS_ACT_FIJOS_ESP: "bandejas-act-fijos-esp",
  BANDEJAS_ACT_FIJOS_VIEW: "bandejas-act-fijos-view",
  BANDEJAS_ACT_FIJOS_CREATE: "bandejas-act-fijos-create",
  BANDEJAS_ACT_FIJOS_EDIT: "bandejas-act-fijos-edit",
  BANDEJAS_ACT_FIJOS_DELETE: "bandejas-act-fijos-delete",
  BANDEJAS_ACT_FIJOS_CONSIGNACION: "bandejas-act-fijos-consignacion",
  T_ASSET_COMMENT: "t-asset-comment",
  T_MKT_COMMENT: "t-mkt-comment",
  T_MKT_ADMIN: "t-mkt-admin",
  T_ACCOUNTING_COMMENT: "t-accounting-comment",
  TICKET_ACCOUNTING_EXPORT: "t-accounting-export",

  // DATA
  DATA_CREATE: "data-create",
  DATA_VIEW: "data-view",
  DATA_EDIT: "data-edit",
  DATA_DELETE: "data-delete",
  DATA_IMPORT: "data-import",
  // TI
  TI_CREATE: "ti-create",
  TI_VIEW: "ti-view",
  TI_OWN_VIEW: "ti-own-view",
  TI_EDIT: "ti-edit",
  TI_DELETE: "ti-delete",
  // ASSETS
  ASSETS_CREATE: "assets-create",
  ASSETS_VIEW: "assets-view",
  ASSETS_EDIT: "assets-edit",
  ASSETS_DELETE: "assets-delete",
  // MARKETING
  MARKETING_CREATE: "marketing-create",
  MARKETING_VIEW: "marketing-view",
  MARKETING_EDIT: "marketing-edit",
  MARKETING_DELETE: "marketing-delete",
  MARKETING_READ: "marketing-read",
  // ACCOUNTING PERU
  ACCOUNTING_PERU_CREATE: "accounting-peru-create",
  ACCOUNTING_PERU_VIEW: "accounting-peru-view",
  ACCOUNTING_PERU_EDIT: "accounting-peru-edit",
  ACCOUNTING_PERU_DELETE: "accounting-peru-delete",
  // ACCOUNTING ECUADOR
  ACCOUNTING_ECUADOR_CREATE: "accounting-ecuador-create",
  ACCOUNTING_ECUADOR_VIEW: "accounting-ecuador-view",
  ACCOUNTING_ECUADOR_EDIT: "accounting-ecuador-edit",
  ACCOUNTING_ECUADOR_DELETE: "accounting-ecuador-delete",
  // PERSONAL
  PERSONAL_CREATE: "personal-create",
  PERSONAL_VIEW: "personal-view",
  PERSONAL_EDIT: "personal-edit",
  PERSONAL_DELETE: "personal-delete",
  GESTION_PERSONAL: "gestion-personal",
  // COMPLIANCE
  COMPLIANCE_CREATE: "compliance-create",
  COMPLIANCE_VIEW: "compliance-view",
  COMPLIANCE_EDIT: "compliance-edit",
  COMPLIANCE_DELETE: "compliance-delete",
  // COMPLIANCE PERÚ
  COMPLIANCE_PERU_CREATE: "compliance-peru-create",
  COMPLIANCE_PERU_VIEW: "compliance-peru-view",
  COMPLIANCE_PERU_EDIT: "compliance-peru-edit",
  COMPLIANCE_PERU_DELETE: "compliance-peru-delete",
  // COMPLIANCE ECUADOR
  COMPLIANCE_ECUADOR_CREATE: "compliance-ecuador-create",
  COMPLIANCE_ECUADOR_VIEW: "compliance-ecuador-view",
  COMPLIANCE_ECUADOR_EDIT: "compliance-ecuador-edit",
  COMPLIANCE_ECUADOR_DELETE: "compliance-ecuador-delete",
  // COMPLIANCE EXPENSE
  COMPLIANCE_EXPENSE_CREATE: "compliance-expense-create",
  COMPLIANCE_EXPENSE_VIEW: "compliance-expense-view",
  COMPLIANCE_EXPENSE_EDIT: "compliance-expense-edit",
  COMPLIANCE_EXPENSE_DELETE: "compliance-expense-delete",
  // COMPLIANCE EXPENSE PERÚ
  COMPLIANCE_EXPENSE_PERU_CREATE: "compliance-expense-peru-create",
  COMPLIANCE_EXPENSE_PERU_VIEW: "compliance-expense-peru-view",
  COMPLIANCE_EXPENSE_PERU_EDIT: "compliance-expense-peru-edit",
  COMPLIANCE_EXPENSE_PERU_DELETE: "compliance-expense-peru-delete",
  // COMPLIANCE EXPENSE ECUADOR
  COMPLIANCE_EXPENSE_ECUADOR_CREATE: "compliance-expense-ecuador-create",
  COMPLIANCE_EXPENSE_ECUADOR_VIEW: "compliance-expense-ecuador-view",
  COMPLIANCE_EXPENSE_ECUADOR_EDIT: "compliance-expense-ecuador-edit",
  COMPLIANCE_EXPENSE_ECUADOR_DELETE: "compliance-expense-ecuador-delete",
  // COMPLIANCE QUALITY
  COMPLIANCE_QUALITY_CREATE: "compliance-quality-create",
  COMPLIANCE_QUALITY_VIEW: "compliance-quality-view",
  COMPLIANCE_QUALITY_EDIT: "compliance-quality-edit",
  COMPLIANCE_QUALITY_DELETE: "compliance-quality-delete",
  // COMPLIANCE AYUDANTÍAS
  AYUDANTIA_CREATE: "ayudantia-create",
  AYUDANTIA_VIEW: "ayudantia-view",
  AYUDANTIA_APPROVE: "ayudantia-approve",
  // INVENTORY PERU
  INVENTORY_PERU_CREATE: "inventory-peru-create",
  INVENTORY_PERU_VIEW: "inventory-peru-view",
  INVENTORY_PERU_EDIT: "inventory-peru-edit",
  INVENTORY_PERU_DELETE: "inventory-peru-delete",
  // INVENTORY ECUADOR
  INVENTORY_ECUADOR_CREATE: "inventory-ecuador-create",
  INVENTORY_ECUADOR_VIEW: "inventory-ecuador-view",
  INVENTORY_ECUADOR_EDIT: "inventory-ecuador-edit",
  INVENTORY_ECUADOR_DELETE: "inventory-ecuador-delete",
  // INVENTORY PROVIDER (catálogo de proveedores del módulo de inventario, /inventory/provider)
  INVENTORY_PROVIDER_ADMIN: "inventory-provider-admin",
  // EDUCATION
  EDUCATION_CREATE: "education-create",
  EDUCATION_VIEW: "education-view",
  EDUCATION_EDIT: "education-edit",
  EDUCATION_DELETE: "education-delete",
  // DOCTOR
  DOCTOR_CREATE: "doctor-create",
  DOCTOR_VIEW: "doctor-view",
  DOCTOR_EDIT: "doctor-edit",
  DOCTOR_DELETE: "doctor-delete",
  // CLINIC
  CLINIC_CREATE: "clinic-create",
  CLINIC_VIEW: "clinic-view",
  CLINIC_EDIT: "clinic-edit",
  CLINIC_DELETE: "clinic-delete",
  // VISIT
  VISIT_CREATE: "visit-create",
  VISIT_VIEW: "visit-view",
  VISIT_EDIT: "visit-edit",
  VISIT_DELETE: "visit-delete",
  // COMERCIAL (Programación mensual de asesores comerciales - Gestión de la App)
  COMERCIAL_CREATE: "comercial-create",
  COMERCIAL_VIEW: "comercial-view",
  COMERCIAL_DELETE: "comercial-delete",
  // USER
  USER_CREATE: "user-create",
  USER_VIEW: "user-view",
  USER_EDIT: "user-edit",
  USER_DELETE: "user-delete",

  // MICROSOFT GRAPH
  MICROSOFT_GRAPH_VIEW: "microsoft-graph-view",

  // TICKET EDITING
  TICKET_FROM_EDIT: "ticket-from-edit",
  TICKET_ASSIGN_EDIT: "ticket-assign-edit",
  ROLES_VIEW: "roles-view",
  TRAVEL_REQUEST_CREATE: "travel-request-create",
  TRAVEL_REQUEST_VIEW: "travel-request-view",
  TRAVEL_REQUEST_EDIT: "travel-request-edit",
  TRAVEL_REQUEST_CANCEL: "travel-request-cancel",
  TRAVEL_REQUEST_ADMIN: "travel-request-admin",
  TRAVEL_REQUEST_EDIT_SUBMITTED: "travel-request-edit-submitted",
  ADDITIONAL_REQUEST_VIEW: "additional-request-view",
  ADDITIONAL_REQUEST_CREATE: "additional-request-create",
  ADDITIONAL_REQUEST_VIEW_EDUCACION_MEDICA: "additional-request-view-educacion-medica",

  // LOGISTICS - PROGRAMACIÓN DE MOTORIZADOS
  LOGISTICS_RIDER_VIEW: "logistics-rider-view",
  LOGISTICS_RIDER_MANAGE: "logistics-rider-manage",
  LOGISTICS_STOP_CREATE: "logistics-stop-create",
  LOGISTICS_STOP_EDIT: "logistics-stop-edit",
  LOGISTICS_STOP_ASSIGN: "logistics-stop-assign",
  LOGISTICS_STOP_CONFIRM: "logistics-stop-confirm",
  LOGISTICS_STOP_CANCEL: "logistics-stop-cancel",
  LOGISTICS_STOP_DELETE: "logistics-stop-delete",
  LOGISTICS_RIDER_CREATE: "logistics-rider-create",
  LOGISTICS_RIDER_EDIT: "logistics-rider-edit",

  // VENTAS - CIRUGÍAS
  SALES_SURGERY_VIEW: "sales-surgery-view",
  SALES_SURGERY_MANAGE: "sales-surgery-manage",

  // LAVADO DE INSTRUMENTAL
  LAVADO_INSTRUMENTAL_CREATE: "lavado-instrumental-create",
  LAVADO_INSTRUMENTAL_VIEW: "lavado-instrumental-view",

  // RENDICIÓN DE GASTOS DE VIAJE
  RENDICION_VIEW: "rendicion-view",
  RENDICION_EDIT: "rendicion-edit",
  RENDICION_APPROVE_PE: "rendicion-approve-pe",
  RENDICION_APPROVE_EC: "rendicion-approve-ec",

  // SISTEMA DE COMPRAS — SOLICITUD DE COMPRA (nuevo, independiente del módulo `compras`/roles PURCHASE_*)
  PROCUREMENT_REQUEST_CREATE: "procurement-request-create",
  PROCUREMENT_REQUEST_VIEW_ALL: "procurement-request-view-all",
  PROCUREMENT_REQUEST_ADMIN: "procurement-request-admin",
  PROCUREMENT_ORDER_CREATE: "procurement-order-create",
  PROCUREMENT_ORDER_VIEW: "procurement-order-view",
  PROCUREMENT_ORDER_PAYMENT_SCHEDULE: "procurement-order-payment-schedule",
  PROCUREMENT_ORDER_PAYMENT_EXCEPTION: "procurement-order-payment-exception",
  PROCUREMENT_ORDER_PAYMENT_ACCOUNTING_REALIZE: "procurement-order-payment-accounting-realize",
  PROCUREMENT_PROVIDER_VIEW: "procurement-provider-view",
  PROCUREMENT_PROVIDER_CREATE: "procurement-provider-create",
  PROCUREMENT_PROVIDER_EDIT: "procurement-provider-edit",
  PROCUREMENT_ADVANCE_CREATE: "procurement-advance-create",
  PROCUREMENT_ADVANCE_VIEW_ALL: "procurement-advance-view-all",
  PROCUREMENT_CATALOG_VIEW: "procurement-catalog-view",
  PROCUREMENT_CATALOG_CREATE: "procurement-catalog-create",
  PROCUREMENT_CATALOG_EDIT: "procurement-catalog-edit",

  // SISTEMA DE COMPRAS ECUADOR (módulo `procurement-ec`, independiente del de Perú). Mismos valores que el back (global.domain.ts).
  PROCUREMENT_EC_REQUEST_CREATE: "procurement-ec-request-create",
  PROCUREMENT_EC_REQUEST_VIEW_ALL: "procurement-ec-request-view-all",
  PROCUREMENT_EC_REQUEST_ADMIN: "procurement-ec-request-admin",
  PROCUREMENT_EC_ORDER_CREATE: "procurement-ec-order-create",
  PROCUREMENT_EC_ORDER_VIEW: "procurement-ec-order-view",
  PROCUREMENT_EC_ORDER_ACCOUNTING: "procurement-ec-order-accounting",
  PROCUREMENT_EC_PROVIDER_VIEW: "procurement-ec-provider-view",
  PROCUREMENT_EC_PROVIDER_CREATE: "procurement-ec-provider-create",
  PROCUREMENT_EC_PROVIDER_EDIT: "procurement-ec-provider-edit",
  PROCUREMENT_EC_ADVANCE_CREATE: "procurement-ec-advance-create",
  PROCUREMENT_EC_ADVANCE_VIEW_ALL: "procurement-ec-advance-view-all",
  PROCUREMENT_EC_ADVANCE_ACCOUNTING: "procurement-ec-advance-accounting",
  PROCUREMENT_EC_REPORT_VIEW: "procurement-ec-report-view",
  PROCUREMENT_EC_ADMIN: "procurement-ec-admin"
} as const

export const AREA = {
  OPERACIONES: "Operaciones",
  COMERCIAL: "Comercial",
  RENOVACIONES: "Renovaciones",
  ADMINISTRATIVO: "Administrativo",
  TI: "TI",
  DESARROLLO_HUMANO: "Gestión Desarrollo Humano",
  SST: "SST"
} as const
